/**
 * Created by piotr.pozniak@thebeaverhead.com on 14/04/2023
 */

import React, { useContext } from "react";
import PropTypes from "prop-types";
import Filters from "../../../component/Filters/Filters";
import IntegrationContext from "../../../../calendar/strategies/IntegrationContext";
import { useCalendarStore } from "../../../../../hooks/redux/calendar";
import useFiltersHook from "../../../hooks/useFiltersHook";

const EventsFiltering = (props) => {
  const integrationStrategy = useContext(IntegrationContext);
  const { calendar } = useCalendarStore();
  const { widgetModel } = props;

  const { availableFilters } = useFiltersHook({
    widget: calendar,
    integrationStrategy,
  });

  const widgetFilters = widgetModel.filter_settings
    ? widgetModel.filter_settings.filters
    : {};

  return (
    <Filters
      availableFilters={availableFilters}
      filters={widgetFilters}
      onChange={props.onUpdateFilters}
    />
  );
};

EventsFiltering.defaultProps = {};

EventsFiltering.propTypes = {
  widgetModel: PropTypes.object,
  integrationModel: PropTypes.object,
};

export default EventsFiltering;
